import { createAuthClient } from '@caterinx/api-client';

/**
 * Die eine Stelle, an der das Lieferantenportal seinen API-Zugang konfiguriert.
 *
 * **Hier steht bewusst keine Logik.** Axios-Instanz, Auth-Interceptor und Refresh-Warteschlange
 * leben in `@caterinx/api-client`, weil `apps/admin` dasselbe braucht. Eine zweite Kopie des
 * Interceptors ist der Fehler, der die getrennte Admin-App (D11) teuer macht.
 */
export const authClient = createAuthClient({
  baseUrl: import.meta.env.VITE_API_URL,
  storagePrefix: 'caterinx',
  loginPath: '/login',
});

/** Vorkonfigurierte Axios-Instanz für alle Aufrufe gegen die REST-API. */
export const api = authClient.http;
